import type { ProfileManifest } from "../../contracts";
import type { ProfileTokenId } from "../../registry/profile-registry";

export const BUILTIN_PROFILES: ProfileManifest<ProfileTokenId>[] = [
    {
        id: "magicmd.documentation",
        label: "Documentation",
        scope: "content",
        values: {
            "content.maxWidth": "72ch",
            "content.fontSize": "0.95rem",
            "content.lineHeight": "1.62",
            "content.paragraphSpacing": "0.34em",
            "content.headingSpacing": "0.6em",
            "content.blockSpacing": "0.58em",
            "content.inlineCodeFontSize": "0.85em",
            "content.codeBlockFontSize": "0.875em",
            "content.listIndent": "1.35rem",
            "content.surfacePadding": "1.25rem",
        },
    },
    {
        id: "magicmd.reading",
        label: "Reading",
        scope: "content",
        values: {
            "content.maxWidth": "78ch",
            "content.fontSize": "1rem",
            "content.lineHeight": "1.7",
            "content.paragraphSpacing": "0.46em",
            "content.headingSpacing": "0.78em",
            "content.blockSpacing": "0.75em",
            "content.inlineCodeFontSize": "0.88em",
            "content.codeBlockFontSize": "0.9em",
            "content.listIndent": "1.5rem",
            "content.surfacePadding": "1.5rem",
        },
    },
    {
        id: "magicmd.paper",
        label: "Paper",
        scope: "presentation",
        values: {
            "presentation.maxWidth": "860px",
            "presentation.fontSize": "17px",
            "presentation.lineHeight": "1.75",
            "presentation.paragraphSpacing": "0.7em",
            "presentation.headingSpacing": "1.1em",
            "presentation.blockSpacing": "1em",
            "presentation.surfacePadding": "2rem",
        },
    },
    {
        id: "magicmd.presenter",
        label: "Presenter",
        scope: "presentation",
        values: {
            "presentation.maxWidth": "960px",
            "presentation.fontSize": "18px",
            "presentation.lineHeight": "1.82",
            "presentation.paragraphSpacing": "0.8em",
            "presentation.headingSpacing": "1.2em",
            "presentation.blockSpacing": "1.1em",
            "presentation.surfacePadding": "2.5rem",
        },
    },
];
